function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "MedalliaMinLogo_svg__a",
  d: "M15.667 6.137l-6.1 7.817-6.1-7.817H0v16.792h3.766V12.566l5.675 7.252h.2l5.731-7.3v10.414h3.766V6.137z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "MedalliaMinLogo_svg__a",
  d: "M6.107 3.461l3.46-3.46 3.461 3.46-3.46 3.46z"
});

function SvgMedalliaMinLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.135 22.93"
  }, props), _ref, _ref2, _ref3);
}

export default SvgMedalliaMinLogo;